<script>
import { userTypes, orderTypes } from "@/store/types/types.js";
import Search from "@/components/Search";
import * as moment from "moment";
export default {
  name: "order-settled",
  components: {
    Search
  },
  data() {
    return {
      date: "",
      userList: [],
      length: 0
    };
  },
  computed: {
    orderList() {
      return this.$store.getters[orderTypes.getters.getOrderList];
    }
  },
  methods: {
    openUserDetail(id) {
      this.userList = this.userList.filter(user => {
        if (user.id === id) {
          user.state = !user.state;
        }
        return user;
      });
    },
    search(data) {
      let q = data.q;
      this.userList = this.orderList.filter(user => {
        let address = user.orderList.reduce((acc, cur) => {
          return (acc += cur.address);
        }, "");
        return (
          user.name.includes(q) ||
          address.includes(q) ||
          user.phone.main.includes(q)
        );
      });
      this.userList = this.userList.slice(0, 30);
    },
    getPage(data) {
      let page = data.page;
      let q = data.q;
      this.userList = this.orderList.filter(user => {
        let address = user.orderList.reduce((acc, cur) => {
          return (acc += cur.address);
        }, "");
        return (
          user.name.includes(q) ||
          address.includes(q) ||
          user.phone.main.includes(q)
        );
      });
      this.userList = this.userList.slice((page - 1) * 30, page * 30);
      let container = this.$el.querySelector(".scroll-view");
      container.scrollTop = -container.scrollHeight;
    },
    editCashBag(event, user) {
      user.is_cashbag_out = event.target.checked ? 1 : 0;
      let data = {
        is_cashbag_out: event.target.checked,
        id: user.id
      };
      this.$store
        .dispatch(userTypes.actions.EDIT_USER_CASH_BAG, data)
        .then(() => {
          this.$store.dispatch(
            orderTypes.actions.GET_ORDER_SETTLED_LIST,
            this.date
          );
        });
    },
    editBag(event, id) {
      let data = {
        is_bag_back: event.target.checked,
        id: id
      };
      this.$store.dispatch(orderTypes.actions.EDIT_ORDER, data).then(() => {
        this.$store.dispatch(
          orderTypes.actions.GET_ORDER_SETTLED_LIST,
          this.date
        );
      });
    },
    editPaid(event, id, index) {
      let data = {
        is_paid: event.target.checked,
        id: id
      };
      this.$store.dispatch(orderTypes.actions.EDIT_ORDER, data).then(() => {
        this.$store.dispatch(
          orderTypes.actions.GET_ORDER_SETTLED_LIST,
          this.date
        );
      });
      this.userList[index].is_amount = this.userList[index].orderList.every(
        order => {
          return order.is_paid;
        }
      );
    },
    clickAllPayment(event, index) {
      let isNotPaidList = this.userList[index].orderList.filter(order => {
        return order.is_paid == this.userList[index].is_amount;
      });
      this.userList[index].orderList.map(order => {
        return (order.is_paid = event.target.checked);
      });
      isNotPaidList.map(order => {
        let data = {
          is_paid: event.target.checked,
          id: order.id
        };
        this.$store.dispatch(orderTypes.actions.EDIT_ORDER, data);
      });
    },
    transToChinese(weekday) {
      let weekdayMapping = ["一", "二", "三", "四", "五"];
      return weekdayMapping[weekday];
    }
  },
  mounted() {
    this.date = moment()
      .endOf("month")
      .format("YYYY-MM-DD");
    this.$store
      .dispatch(orderTypes.actions.GET_ORDER_SETTLED_LIST, this.date)
      .then(() => {
        this.userList = this.orderList.sort((a, b) => {
          return (
            b.is_cashbag_out - a.is_cashbag_out ||
            moment(a.cashbag_out_at) - moment(b.cashbag_out_at)
          );
        });
        this.length = this.orderList.length;
      });
  }
};
</script>


<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
